export const translations = {
  en: {
    nav: {
      story: "The Story",
      journey: "The Journey",
      table: "The Table",
      tiers: "Tiers",
      reserve: "Reserve",
    },
    hero: {
      overline: "Afro–Swiss Soul Food · Baden · Römerquartier",
      title_a: "The best",
      title_b: "of both",
      title_c: "worlds.",
      sub: "A monthly private table in a home in Baden's Römerquartier, hosted by Richard Grob — winner of SRF's ‘Mini Chuchi, dini Chuchi'. Six seats, one departure, one evening balanced between two kitchens.",
      cta_primary: "Reserve a seat",
      cta_secondary: "Read the journey",
      marquee: "Afro · Swiss · Soul · Food · Baden · Römerquartier · Private Table · Six Seats · Boarding Soon ·",
      plate_label: "Winning Plate",
      city_label: "Baden · CH",
      status_label: "Next departure · TBA",
    },
    story: {
      overline: "The Food Journey",
      title: "A plate that travels —\nfrom Lagos to the Limmat.",
      lead:
        "Afro-Swiss Soul Food is not fusion for the sake of novelty. It is a quiet, deliberate conversation between two kitchens that already live inside one man — Richard Grob, born in Lagos in 1969, at home in Baden since 1988.",
      p1:
        "The winning menu on SRF's ‘Mini Chuchi, dini Chuchi' told the whole story on one plate: crispy plantains, tomatoes and Kefen, chicken wings, lamb chops with okra. West-African warmth, Swiss precision, and a balance the jury remembered long after the dishes were cleared.",
      p2:
        "There is no shock, no over-spicing, no exotic performance. ‘It would be far too sharp and exotic for the Swiss palate,' Richard says of the Egusi soups of his childhood. Instead he seeks the culinary middle — the same middle he found between Lagos and Baden, between mechanical engineering and IT, between his Nigerian roots and his Swiss papers.",
      p3:
        "What lands on the table is neither African nor Swiss. It is a third place, born in one biography and shared with five other guests each month around a single long table in the Römerquartier. A boarding pass to somewhere new — the same somewhere, gently different each time.",
      pull:
        "\u201CThe best of both worlds — the two that unite within me.\u201D",
      signature: "— Richard Grob",
    },
    table: {
      overline: "The Private Table",
      title: "Six seats. One evening a month.",
      copy:
        "We host a single dinner each month, in a private home in Baden's Römerquartier. The room is small on purpose: six guests, one long table, a kitchen you can see and smell. There is no menu to choose from — only the journey Richard has prepared, served slowly, finished honestly.",
      facts: [
        { label: "Format", value: "Private dining" },
        { label: "Capacity", value: "6 seats" },
        { label: "Cadence", value: "Monthly" },
        { label: "City", value: "Baden, CH" },
      ],
    },
    tiers: {
      overline: "À la carte by design",
      title: "Two ways to come to the table.",
      sub: "Both journeys share the full five-course tasting menu. Choose whether the evening travels with water — or with wine.",
      items: [
        {
          name: "The Tasting",
          tag: "Water pairing",
          price: "CHF 69",
          per: "/ seat",
          includes: [
            "Five-course Afro-Swiss tasting",
            "Sparkling and still water throughout",
            "Welcome bite in the kitchen",
            "Signed printed menu to take home",
          ],
        },
        {
          name: "The Pairing",
          tag: "Wine pairing",
          price: "CHF 99",
          per: "/ seat",
          includes: [
            "Everything in The Tasting",
            "Two wines to choose from",
            "Poured across the courses",
            "Chef's table conversation",
          ],
          featured: true,
        },
      ],
      cta: "Reserve a seat",
    },
    boarding: {
      overline: "Coming Soon",
      title: "The Boarding Gate.",
      sub:
        "Reservations will open through a seat-map experience modelled on a real airline gate. You pick your seat, your neighbour, your departure — and a boarding pass lands directly in your Apple or Google Wallet, surfacing on the day of the dinner like the real thing.",
      seatmap_title: "Gate BAD · Table 01",
      seatmap_sub: "Six-seat cabin · single departure per month",
      seatmap_meta_live: "LIVE · DEMO",
      seatmap_cabin: "Cabin · 6 PAX",
      seatmap_class: "Class · Soul",
      seat_legend: ["Available", "Selected", "Reserved"],
      pass: {
        airline: "Afro-Swiss Soul Food",
        boarding_label: "BOARDING PASS · ASS · 06",
        from: "BAD",
        to: "TBL",
        from_label: "Baden",
        to_label: "The Table",
        from_prefix: "From",
        to_prefix: "To",
        passenger_label: "Passenger",
        passenger: "Guest of the Chef",
        seat_label: "Seat",
        seat: "Seat 03A",
        date_label: "Date",
        date: "Sat · 20:00",
        gate_label: "Gate",
        gate: "Römerquartier",
        flight: "ASS · 06",
      },
      status: "Boarding window opening soon",
      notify_placeholder: "Your email — be first in line",
      notify_cta: "Notify me",
      notify_success: "You're on the list. Boarding details will arrive in your inbox.",
      notify_error: "Something went wrong. Please try again.",
      wallet: ["Apple Wallet ready", "Google Wallet ready"],
    },
    footer: {
      tagline: "The best of both worlds.",
      contact: "Contact",
      email_label: "Reservations",
      city: "Baden · Switzerland",
      links_title: "Wander",
      links: ["The Journey", "The Table", "Tiers", "Boarding Gate", "Support"],
      legal: "© 2026 Afro-Swiss Soul Food · Richard Grob, Baden. All rights reserved.",
      built: "Crafted slowly, served warm.",
    },
    support: {
      nav: "Support",
      overline: "Passenger Help",
      title: "Everything you need\nto board smoothly.",
      lead:
        "Questions about your reservation, dietary needs, or the boarding pass in your wallet? The kitchen is small — and so is our support desk. Richard reads every message personally, usually within one working day.",
      channels_title: "Reach the kitchen",
      channels: [
        { label: "Email", value: "hello@afro-swiss-soulfood.ch", href: "mailto:hello@afro-swiss-soulfood.ch" },
        { label: "Phone", value: "+41 44 000 00 00", href: "tel:+41440000000" },
        { label: "Hours", value: "Mon–Fri · 10:00–18:00 CET", href: null },
        { label: "Response", value: "Within 1 working day", href: null },
      ],
      faq_overline: "Frequently asked",
      faq_title: "Before you write in.",
      faqs: [
        {
          q: "How do reservations work?",
          a: "Each month we host a single dinner for six guests in a private home in Baden's Römerquartier. When the boarding window opens, you'll pick your seat on the seat-map, confirm date and tier, and receive a boarding pass in your Apple or Google Wallet.",
        },
        {
          q: "Can I book seats next to a friend?",
          a: "Yes. During seat selection you can pick multiple adjacent seats in a single booking. Seats other guests have already reserved are marked as unavailable in real time.",
        },
        {
          q: "What is included in each tier?",
          a: "Both tiers share the same five-course tasting menu. CHF 69 comes with sparkling and still water throughout the evening. CHF 99 adds a two-wine pairing — you choose between two curated pours — served across the courses.",
        },
        {
          q: "How does the boarding pass work?",
          a: "After you confirm a reservation, a pass is issued directly to Apple Wallet or Google Wallet. On the day of the dinner it surfaces as a time-sensitive notification — the same way a real airline boarding pass moves to the top of your lock screen on departure day.",
        },
        {
          q: "What if I have dietary requirements or allergies?",
          a: "Write to us as early as possible after booking. Because the menu is fixed and paced for six guests, we adapt courses individually rather than swapping the whole menu — please give us at least seven days' notice.",
        },
        {
          q: "What's your cancellation policy?",
          a: "Free cancellation up to seven days before the dinner. Between seven and forty-eight hours, 50% is retained. Inside 48 hours the full seat fee is retained, unless we can rebook your seat.",
        },
        {
          q: "Do you host private buy-outs?",
          a: "Yes. You can book all six seats for a private event on a non-scheduled evening. Contact Richard with your preferred date and we'll build a bespoke menu around it.",
        },
      ],
      form_overline: "Write to the kitchen",
      form_title: "Send us a message.",
      form_sub: "Please tell us as much as you can — your reservation reference, dinner date, or wallet pass issue helps us answer fast.",
      form: {
        name_label: "Your name",
        name_placeholder: "Full name",
        email_label: "Email",
        email_placeholder: "you@example.com",
        topic_label: "Topic",
        topic_placeholder: "Select a topic",
        topics: [
          { value: "reservation", label: "Reservation" },
          { value: "wallet", label: "Boarding pass / Wallet" },
          { value: "dietary", label: "Dietary or allergy" },
          { value: "private", label: "Private buy-out" },
          { value: "press", label: "Press or partnership" },
          { value: "other", label: "Something else" },
        ],
        ref_label: "Booking reference (optional)",
        ref_placeholder: "ASS-06-…",
        message_label: "Message",
        message_placeholder: "Tell us how we can help.",
        submit: "Send message",
        submitting: "Sending…",
        success: "Message received. We'll reply within one working day.",
        error: "Something went wrong. Please try again, or write to hello@afro-swiss-soulfood.ch",
        validation: "Please fill in name, a valid email, topic and message.",
      },
      back_home: "Back to home",
    },
    lang: { en: "EN", de: "DE" },
  },
  de: {
    nav: {
      story: "Die Geschichte",
      journey: "Die Reise",
      table: "Der Tisch",
      tiers: "Stufen",
      reserve: "Reservieren",
    },
    hero: {
      overline: "Afro–Swiss Soul Food · Baden · Römerquartier",
      title_a: "Das Beste",
      title_b: "aus zwei",
      title_c: "Welten.",
      sub: "Ein monatlicher privater Tisch in einem Zuhause im Badener Römerquartier, ausgerichtet von Richard Grob — Sieger der SRF-Sendung ‘Mini Chuchi, dini Chuchi'. Sechs Plätze, ein Abflug, ein Abend im Gleichgewicht zwischen zwei Küchen.",
      cta_primary: "Platz reservieren",
      cta_secondary: "Die Reise lesen",
      marquee: "Afro · Swiss · Soul · Food · Baden · Römerquartier · Privater Tisch · Sechs Plätze · Bald boarden ·",
      plate_label: "Gewinner-Teller",
      city_label: "Baden · CH",
      status_label: "Nächster Abflug · TBA",
    },
    story: {
      overline: "Die kulinarische Reise",
      title: "Ein Teller, der reist —\nvon Lagos an die Limmat.",
      lead:
        "Afro-Swiss Soul Food ist keine Fusion um der Neuheit willen. Es ist ein leiser, bewusster Dialog zweier Küchen, die bereits in einem Menschen zusammenleben — Richard Grob, geboren 1969 in Lagos, zuhause in Baden seit 1988.",
      p1:
        "Das Siegermenü in der SRF-Sendung ‘Mini Chuchi, dini Chuchi' erzählte die ganze Geschichte auf einem Teller: knusprige Kochbananen, Tomaten und Kefen, Pouletflügeli, Lamm-Koteletts mit Okra. Westafrikanische Wärme, Schweizer Präzision — und eine Balance, die der Jury lange nach dem Abräumen im Gedächtnis blieb.",
      p2:
        "Kein Schock, keine überschärfte Würze, keine exotische Show. ‘Es wäre viel zu scharf und exotisch für den Schweizer Gaumen', sagt Richard über die Egusi-Suppen seiner Kindheit. Stattdessen sucht er die kulinarische Mitte — dieselbe Mitte, die er zwischen Lagos und Baden fand, zwischen Maschinenbau und IT, zwischen nigerianischen Wurzeln und Schweizer Papieren.",
      p3:
        "Was auf den Tisch kommt, ist weder afrikanisch noch schweizerisch. Es ist ein dritter Ort, entstanden in einer Biografie und geteilt jeden Monat mit fünf weiteren Gästen an einem einzigen langen Tisch im Römerquartier. Eine Bordkarte zu etwas Neuem — dasselbe Neue, jedes Mal sanft anders.",
      pull:
        "\u201EDas Beste aus beiden Welten, die sich in mir vereinen.\u201C",
      signature: "— Richard Grob",
    },
    table: {
      overline: "Der private Tisch",
      title: "Sechs Plätze. Ein Abend pro Monat.",
      copy:
        "Wir veranstalten ein einziges Abendessen im Monat, in einem privaten Zuhause im Badener Römerquartier. Der Raum ist mit Absicht klein: sechs Gäste, ein langer Tisch, eine Küche, die man sehen und riechen kann. Es gibt keine Karte — nur die Reise, die Richard vorbereitet hat, langsam serviert, ehrlich beendet.",
      facts: [
        { label: "Format", value: "Privates Dinner" },
        { label: "Plätze", value: "6 Sitze" },
        { label: "Rhythmus", value: "Monatlich" },
        { label: "Stadt", value: "Baden, CH" },
      ],
    },
    tiers: {
      overline: "À la carte gedacht",
      title: "Zwei Wege an den Tisch.",
      sub: "Beide Reisen teilen das gleiche Fünf-Gang-Menü. Sie entscheiden, ob der Abend mit Wasser reist — oder mit Wein.",
      items: [
        {
          name: "Die Verkostung",
          tag: "Wasser-Begleitung",
          price: "CHF 69",
          per: "/ Platz",
          includes: [
            "Fünf-Gang Afro-Swiss-Menü",
            "Wasser mit und ohne Kohlensäure",
            "Begrüßungsbissen in der Küche",
            "Signierte gedruckte Karte zum Mitnehmen",
          ],
        },
        {
          name: "Die Begleitung",
          tag: "Wein-Begleitung",
          price: "CHF 99",
          per: "/ Platz",
          includes: [
            "Alles aus Die Verkostung",
            "Zwei Weine zur Auswahl",
            "Über die Gänge ausgeschenkt",
            "Gespräch am Chef's Table",
          ],
          featured: true,
        },
      ],
      cta: "Platz reservieren",
    },
    boarding: {
      overline: "Bald verfügbar",
      title: "Das Boarding-Gate.",
      sub:
        "Reservierungen werden über eine Sitzkarte geöffnet, die einem echten Flughafen-Gate nachempfunden ist. Sie wählen Ihren Platz, Ihren Nachbarn, Ihren Abflug — und eine Bordkarte landet direkt in Ihrem Apple oder Google Wallet, die am Tag des Dinners erscheint wie eine echte.",
      seatmap_title: "Gate BAD · Tisch 01",
      seatmap_sub: "Sechs-Sitz-Kabine · ein Abflug pro Monat",
      seatmap_meta_live: "LIVE · DEMO",
      seatmap_cabin: "Kabine · 6 PAX",
      seatmap_class: "Klasse · Soul",
      seat_legend: ["Verfügbar", "Ausgewählt", "Reserviert"],
      pass: {
        airline: "Afro-Swiss Soul Food",
        boarding_label: "BORDKARTE · ASS · 06",
        from: "BAD",
        to: "TBL",
        from_label: "Baden",
        to_label: "Der Tisch",
        from_prefix: "Von",
        to_prefix: "Nach",
        passenger_label: "Passagier",
        passenger: "Gast des Chefs",
        seat_label: "Sitz",
        seat: "Sitz 03A",
        date_label: "Datum",
        date: "Sa · 20:00",
        gate_label: "Gate",
        gate: "Römerquartier",
        flight: "ASS · 06",
      },
      status: "Boarding-Fenster öffnet bald",
      notify_placeholder: "Ihre E-Mail — als Erstes an Bord",
      notify_cta: "Benachrichtigen",
      notify_success: "Sie sind auf der Liste. Die Boarding-Details kommen per E-Mail.",
      notify_error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      wallet: ["Apple Wallet bereit", "Google Wallet bereit"],
    },
    footer: {
      tagline: "Das Beste aus beiden Welten.",
      contact: "Kontakt",
      email_label: "Reservierungen",
      city: "Baden · Schweiz",
      links_title: "Wandern",
      links: ["Die Reise", "Der Tisch", "Stufen", "Boarding-Gate", "Support"],
      legal: "© 2026 Afro-Swiss Soul Food · Richard Grob, Baden. Alle Rechte vorbehalten.",
      built: "Langsam gekocht, warm serviert.",
    },
    support: {
      nav: "Support",
      overline: "Passagier-Hilfe",
      title: "Alles, was Sie brauchen,\num sanft an Bord zu gehen.",
      lead:
        "Fragen zur Reservierung, zu Ernährungsbedürfnissen oder zu Ihrer Bordkarte im Wallet? Die Küche ist klein — und der Support-Tisch auch. Richard liest jede Nachricht persönlich, meist innerhalb eines Werktages.",
      channels_title: "Die Küche erreichen",
      channels: [
        { label: "E-Mail", value: "hello@afro-swiss-soulfood.ch", href: "mailto:hello@afro-swiss-soulfood.ch" },
        { label: "Telefon", value: "+41 44 000 00 00", href: "tel:+41440000000" },
        { label: "Zeiten", value: "Mo–Fr · 10:00–18:00 MEZ", href: null },
        { label: "Antwort", value: "Innerhalb eines Werktages", href: null },
      ],
      faq_overline: "Häufig gefragt",
      faq_title: "Bevor Sie schreiben.",
      faqs: [
        {
          q: "Wie funktionieren die Reservierungen?",
          a: "Jeden Monat veranstalten wir ein einziges Dinner für sechs Gäste in einem privaten Zuhause im Badener Römerquartier. Wenn das Boarding-Fenster öffnet, wählen Sie Ihren Platz über die Sitzkarte, bestätigen Datum und Stufe und erhalten eine Bordkarte in Ihr Apple oder Google Wallet.",
        },
        {
          q: "Kann ich Plätze neben einem Freund buchen?",
          a: "Ja. Bei der Sitzauswahl können Sie in einer einzigen Buchung mehrere benachbarte Plätze wählen. Bereits reservierte Plätze werden in Echtzeit als nicht verfügbar markiert.",
        },
        {
          q: "Was ist in jeder Stufe enthalten?",
          a: "Beide Stufen teilen das gleiche Fünf-Gang-Menü. CHF 69 kommt mit Wasser mit und ohne Kohlensäure über den ganzen Abend. CHF 99 fügt eine Zwei-Wein-Begleitung hinzu — Sie wählen zwischen zwei kuratierten Weinen — über die Gänge ausgeschenkt.",
        },
        {
          q: "Wie funktioniert die Bordkarte?",
          a: "Nach Bestätigung der Reservierung wird eine Bordkarte direkt an Apple Wallet oder Google Wallet ausgestellt. Am Tag des Dinners erscheint sie als zeitkritische Benachrichtigung — genauso wie eine echte Bordkarte am Abflugtag oben auf dem Sperrbildschirm landet.",
        },
        {
          q: "Was, wenn ich Diät- oder Allergie-Vorgaben habe?",
          a: "Schreiben Sie uns so früh wie möglich nach der Buchung. Da das Menü fest ist und für sechs Gäste getaktet, passen wir Gänge individuell an, statt das ganze Menü zu tauschen — bitte mindestens sieben Tage im Voraus.",
        },
        {
          q: "Wie ist Ihre Stornierungsrichtlinie?",
          a: "Kostenlose Stornierung bis sieben Tage vor dem Dinner. Zwischen sieben und achtundvierzig Stunden werden 50 % einbehalten. Innerhalb von 48 Stunden bleibt die volle Sitzgebühr einbehalten, es sei denn, wir können Ihren Platz weitervermitteln.",
        },
        {
          q: "Bieten Sie private Buy-outs an?",
          a: "Ja. Sie können alle sechs Plätze für eine private Veranstaltung an einem nicht angesetzten Abend buchen. Kontaktieren Sie Richard mit Ihrem Wunschdatum und wir gestalten ein passendes Menü.",
        },
      ],
      form_overline: "Der Küche schreiben",
      form_title: "Nachricht senden.",
      form_sub: "Bitte sagen Sie uns so viel wie möglich — Ihre Reservierungsnummer, das Datum des Dinners oder das Problem mit dem Wallet-Pass hilft uns, schnell zu antworten.",
      form: {
        name_label: "Ihr Name",
        name_placeholder: "Vollständiger Name",
        email_label: "E-Mail",
        email_placeholder: "sie@beispiel.com",
        topic_label: "Thema",
        topic_placeholder: "Thema auswählen",
        topics: [
          { value: "reservation", label: "Reservierung" },
          { value: "wallet", label: "Bordkarte / Wallet" },
          { value: "dietary", label: "Ernährung oder Allergie" },
          { value: "private", label: "Privater Buy-out" },
          { value: "press", label: "Presse oder Partnerschaft" },
          { value: "other", label: "Etwas anderes" },
        ],
        ref_label: "Buchungsreferenz (optional)",
        ref_placeholder: "ASS-06-…",
        message_label: "Nachricht",
        message_placeholder: "Sagen Sie uns, wie wir helfen können.",
        submit: "Nachricht senden",
        submitting: "Wird gesendet…",
        success: "Nachricht erhalten. Wir antworten innerhalb eines Werktages.",
        error: "Etwas ist schiefgelaufen. Bitte erneut versuchen oder an hello@afro-swiss-soulfood.ch schreiben.",
        validation: "Bitte Name, gültige E-Mail, Thema und Nachricht ausfüllen.",
      },
      back_home: "Zurück zur Startseite",
    },
    lang: { en: "EN", de: "DE" },
  },
};
